import { useContext, useEffect, useState } from 'react';

import AuthContext from '../../store/AuthContext';
import AuthCodeInfo from './AuthCodeInfo';
import AuthCodeCmd from './AuthCodeCmd';
import * as utils from '../../services/utils';

import '../Main.css';

const authorizeParam = utils.AUTH_INFO;
const authCodeResponseType = utils.AUTH_CODE_RESPONSE_TYPE;

function AuthCodeMain() {
  const iuaCtx = useContext(AuthContext);

  const [validationMsg, setValidationMsg] = useState('');
  
  useEffect(() => {
    sessionStorage.clear();
    iuaCtx.clear();
  }, []);
  
  useEffect(() => {
    handleDisplayCmdData();
  }, [iuaCtx]);
  
  const iuaConnectProps = {
    handleDisplayCmdData: handleDisplayCmdData
  };

  const iuaCmdProps = {
    buildAuthCmd: buildAuthCmd
  };

  function handleDisplayCmdData() {
    const cmdData = iuaConnectProps.getData(); 
    iuaCmdProps.displayCmdData(cmdData);
  }

  let authorizeData = '';

  function buildAuthCmd() {
    authorizeData = iuaConnectProps.getData();

    let  codeURL =  `${authorizeData.authorizeUri}`;
    codeURL = codeURL.concat(`?${authorizeParam.clientId}=${authorizeData.clientId}`);
    codeURL = codeURL.concat(`&${authorizeParam.redirectUri}=${authorizeData.redirectUri}`);
    codeURL = codeURL.concat(`&${authorizeParam.responseType}=${authCodeResponseType}`);
    codeURL = authorizeData.scopes ? codeURL.concat(`&${authorizeParam.scopes}=${authorizeData.scopes}`) : codeURL;
    codeURL = authorizeData.codeChallenge ? codeURL.concat(`&${authorizeParam.codeChallenge}=${authorizeData.codeChallenge}`) : codeURL;
    codeURL = authorizeData.codeChallengeMethod ? codeURL.concat(`&${authorizeParam.codeChallengeMethod}=${authorizeData.codeChallengeMethod}`) : codeURL;
    codeURL = authorizeData.state ? codeURL.concat(`&${authorizeParam.state}=${authorizeData.state}`) : codeURL;
    codeURL = authorizeData.nonce ? codeURL.concat(`&${authorizeParam.nonce}=${authorizeData.nonce}`) : codeURL;
    // console.log(codeURL);
    return codeURL;
  }

  async function submitHandler(event) {
    event.preventDefault();
    const result = await iuaConnectProps.trigger();
    if (!result) {
      setValidationMsg('Could not submit the request due to missing or invalid input data. Review the data entered.');
      return;
    } 

    const codeURL = buildAuthCmd();
    // console.log('codeURL', codeURL);

    sessionStorage.setItem('transType', utils.TRANS.auth_code);
    sessionStorage.setItem('tokenUri', authorizeData.tokenUri);
    sessionStorage.setItem('clientId', authorizeData.clientId);
    sessionStorage.setItem('clientSecret', authorizeData.clientSecret);
    sessionStorage.setItem('redirectUri', authorizeData.redirectUri);
    sessionStorage.setItem('codeVerifier', authorizeData.codeVerifier);

    window.location.href = codeURL;
  }

  return (
  <div>
    <div className="container main-body">
      <form className="main-form">
      
        <AuthCodeInfo connectData={iuaConnectProps}></AuthCodeInfo>

        <div className="row">
          <div className="col-8">
            <AuthCodeCmd cmdData={iuaCmdProps}></AuthCodeCmd>
          </div>
        </div>

        <div className="row">
          <div className="col-8">
            <div className="main-form-submit validation-msg error">

              {/* VALIDATION MSG */}

              <div>{validationMsg}</div>

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-7">
            <div className="main-form-submit">

              {/* AUTHORIZATION CODE */}

              <button onClick={submitHandler} className="btn btn-danger main-form-submit-button"> Send Request 
                {/* <i className="fa fa-paper-plane-o ml-1"></i> */}
              </button>

            </div>
          </div>
        </div>

      </form>
    </div>
  </div>  
  );
}

export default AuthCodeMain;
